import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { PipelinePageUrls, PipelineSwitcherService } from './pipeline-switcher.service';
import { PipelineBoardViews, PipelinePageCacheService } from '../pipeline/cache/pipeline-page-cache.service';

@Component({
  selector: 'sales-ui-pipeline-switcher',
  templateUrl: './pipeline-switcher.component.html',
  styleUrls: ['./pipeline-switcher.component.scss'],
})
export class PipelineSwitcherComponent {
  readonly currentPage$: Observable<PipelinePageUrls>;
  pipelineView: PipelineBoardViews;

  constructor(
    private readonly pipelineSwitcherService: PipelineSwitcherService,
    private readonly cache: PipelinePageCacheService,
  ) {
    this.pipelineView = this.cache.lastViewedPipelinePageView || PipelineBoardViews.DEFAULT_TABLE;
    this.currentPage$ = this.pipelineSwitcherService.cachedPipelinePage$;
  }

  navigateToTable(): void {
    this.pipelineView = PipelineBoardViews.DEFAULT_TABLE;
    this.pipelineSwitcherService.navigateToTable();
  }

  navigateToBoard(): void {
    this.pipelineView = PipelineBoardViews.DEFAULT_BOARD;
    this.pipelineSwitcherService.navigateToBoard();
  }
}
